import { twMerge } from 'src/utils/tw-merge.util'

export type ListItem = {
  label: string
  value: React.ReactNode
}

interface ListProps extends React.ComponentPropsWithoutRef<'li'> {
  list: ListItem[]
  ordered?: boolean
}

const List = ({ list, ordered, className }: ListProps) => {
  return (
    <ul className="c-space-y-3">
      {list.map((item, index) => (
        <li
          key={`${item.label}-${index}`}
          className={twMerge(
            'c-flex c-justify-between c-items-center c-text-base c-border-b c-border-gray-300 c-pb-3 c-gap-x-14',
            index === list.length - 1 && 'c-border-b-0 c-pb-0',
            className,
          )}
        >
          <div className="c-flex c-items-center c-gap-7 c-flex-1 c-text-sm">
            {ordered && <div>{index < 9 ? `0${index + 1}` : index + 1}</div>}
            <div>{item.label}</div>
          </div>
          {item.value}
        </li>
      ))}
    </ul>
  )
}

export default List
